/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_PublishInputs */

const vi_einvoice_publish = /** @type {(inputs: Einvoice_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất bản`)
};

/**

* @param {Einvoice_PublishInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_publish = /** @type {((inputs?: Einvoice_PublishInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_PublishInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_publish(inputs)
});